import { useEffect, useMemo, useState } from "react";
import { INITIAL_MARKET_PRICE_SETTING } from "../const/marketPriceInitial"
import useYupValidation from "../../../hooks/useYupValidation";
import { marketPriceSchema, marketPriceCustomCheck, validMarketPriceNameSync } from "../validation/validationSchema";

export const useMarketPriceSettingValidation = (form) => {

  const {
    touched,
    handleValidate,
    handleTouch,
    setCustomError
  } = useYupValidation(marketPriceSchema, marketPriceCustomCheck);

  useEffect(() => {
    validMarketPriceNameSync("", true);
  }, []);

  const errors = useMemo(() => {
    const setting = form.marketPriceSetting;
    const errs = handleValidate(setting, false);

    //市況価格名がすでに存在するかどうか確認する。
    const marketPriceNameExisted = validMarketPriceNameSync(setting.marketPriceName, true);

    if (
      marketPriceNameExisted
        && !form.hasSameNameAsOriginal()
    ) {
      errs["marketPriceName"] = "すでに使われている市況価格表名です。";
    }

    // 使用店舗のバリデーションを成型する
    const usingShopsErrors
      = setting.usingShops
          .map((_, index) => ({
              customerId: errs[`usingShops[${index}].customerId`] || "",
              shopId: errs[`usingShops[${index}].shopId`] || "",
          }));

    errs["usingShops"] = usingShopsErrors;
    
    return errs;
  }, [form.marketPriceSetting]);

  const hasErrors = () => {
    const {usingShops, ...otherErrors} = errors;
    
    return Object.keys(otherErrors).length > 0;
  }

  return {
    errors,
    hasErrors
  }
}